import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import FormPrompt from "../DailogBoxes/formprompt";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddStylist from "./addstylist";
import { setstylist } from "../../actions/setstylistaction";
import { isVendorRole, getVendorId } from "../../utils/rbac";

import "./stylistlist.css";

const StylistList = (props) => {
  const history = useHistory();
  const vendorLocked = isVendorRole();
  const lockedVendorId = vendorLocked ? getVendorId() : "";
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [allStylistList, setAllStylistList] = useState([]);
  const [stylistList, setStylistList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendorFilter, setSelectedVendorFilter] = useState(lockedVendorId);
  const [vendorCodeFilter, setVendorCodeFilter] = useState("");
  const [vendorCodeFilterError, setVendorCodeFilterError] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedStylistName, setSelectedStylistName] = useState("");
  const [selectedStylistId, setSelectedStylistId] = useState("");

  useEffect(() => {
    onFetchAll();
  }, []);

  const onFetchAll = async () => {
    setIsLoading(true);
    const [fetchedStylists, fetchedVendors] = await Promise.all([
      Service.getAllData("stylists"),
      Service.getAllData("vendors"),
    ]);
    setAllStylistList(fetchedStylists);
    setStylistList(fetchedStylists);
    setVendorList(fetchedVendors);
    setIsLoading(false);
  };

  useEffect(() => {
    let filtered = [...allStylistList];
    if (selectedVendorFilter) {
      filtered = filtered.filter((s) => s.vendorId === selectedVendorFilter);
    }
    if (searchText) {
      const lower = searchText.toLowerCase();
      filtered = filtered.filter((s) =>
        (s.name || "").toLowerCase().includes(lower)
      );
    }
    setStylistList(filtered);
  }, [selectedVendorFilter, searchText, allStylistList]);

  const handleVendorCodeFilterSearch = () => {
    if (!vendorCodeFilter) {
      setSelectedVendorFilter("");
      setVendorCodeFilterError("");
      return;
    }
    const found = vendorList.find((v) => v.vendorCode === vendorCodeFilter);
    if (found) {
      setSelectedVendorFilter(found.uid);
      setVendorCodeFilterError("");
    } else {
      setVendorCodeFilterError("Vendor code not found");
    }
  };

  const getVendorCode = (vendorId) => {
    const vendor = vendorList.find((v) => v.uid === vendorId);
    return vendor ? vendor.vendorCode || vendorId : vendorId;
  };

  const handleOnEdit = (stylist) => {
    props.setOnStylist(stylist);
    history.push("/editstylist");
  };

  const handleOnDelete = (name, id) => {
    setSelectedStylistName(name);
    setSelectedStylistId(id);
    setOpenConfirmDailog(true);
  };

  const handleToggleActive = async (stylistId, currentStatus) => {
    const res = await Service.updateData(
      { active: !currentStatus },
      "stylists",
      stylistId
    );
    if (res === "success") {
      setAllStylistList((prev) =>
        prev.map((s) =>
          s.stylistId === stylistId ? { ...s, active: !currentStatus } : s
        )
      );
    }
  };

  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("stylists", selectedStylistId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      setAllStylistList((prev) =>
        prev.filter((s) => s.stylistId !== selectedStylistId)
      );
    } else {
      setIsDeleting(false);
      setOpenErrorDailog(true);
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
    onFetchAll();
  };

  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(true);
  };

  let count = 0;

  return isLoading ? (
    <div className="stylistlistpage">
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div className="stylistlistpage">
      <div className="main_section">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={() => setOpenConfirmDailog(false)}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={`Are you sure to delete ${selectedStylistName}?`}
        />
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={() => setOpenAlertDailog(false)}
          title="Success"
          des="Stylist saved successfully"
        />
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={() => setOpenErrorDailog(false)}
          title="Error"
          des="Something went wrong. Try again"
        />

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New Stylist"
          onSetOpenDailog={() => setOpenFormDailog(false)}
        >
          <AddStylist
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
          />
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i>
            </li>
            <li>
              <h5>Stylists</h5>
            </li>
          </ul>
        </div>
        <hr />

        {/* Filter bar */}
        <div
          style={{
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
          }}
        >
          <div className="form-row align-items-end">
            {!vendorLocked && (
            <div className="col-md-4 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Filter by Vendor Code
              </label>
              <div className="input-group input-group-sm">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter vendor code"
                  value={vendorCodeFilter}
                  onChange={(e) => {
                    setVendorCodeFilter(e.target.value);
                    if (!e.target.value) {
                      setSelectedVendorFilter("");
                      setVendorCodeFilterError("");
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleVendorCodeFilterSearch()}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={handleVendorCodeFilterSearch}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
              {vendorCodeFilterError && <small style={{ color: "red" }}>{vendorCodeFilterError}</small>}
              {selectedVendorFilter && !vendorCodeFilterError && (
                <small style={{ color: "green" }}>
                  {vendorList.find((v) => v.uid === selectedVendorFilter)?.salonName || "Vendor found"}
                </small>
              )}
            </div>
            )}
            <div className="col-md-4 mb-2">
              <label style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>
                Search by Name
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search stylist..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-2 mb-2">
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => {
                  setSelectedVendorFilter("");
                  setVendorCodeFilter("");
                  setVendorCodeFilterError("");
                  setSearchText("");
                }}
              >
                Clear
              </button>
            </div>
            <div className="col-md-2 mb-2 text-right">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => setOpenFormDailog(true)}
              >
                + Add Stylist
              </button>
            </div>
          </div>
        </div>

        <table className="table table-striped">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Role</th>
              <th scope="col">Experience</th>
              <th scope="col">Vendor</th>
              <th scope="col">Added On</th>
              <th scope="col">Status</th>
              <th scope="col">Option</th>
            </tr>
          </thead>
          <tbody className="tablebody">
            {stylistList.length === 0 ? (
              <tr>
                <td colSpan="9">No stylists found</td>
              </tr>
            ) : (
              stylistList.map((s) => {
                count++;
                return (
                  <tr key={s.stylistId}>
                    <td className="align-middle">{count}</td>
                    <td className="align-middle">
                      {s.image ? (
                        <img className="image" alt="" srcSet={s.image} />
                      ) : (
                        <div className="userbg">
                          <i className="fa fa-user fa-lg"></i>
                        </div>
                      )}
                    </td>
                    <td className="align-middle">{s.name}</td>
                    <td className="align-middle">{s.role}</td>
                    <td className="align-middle">{s.experience}</td>
                    <td className="align-middle">{getVendorCode(s.vendorId)}</td>
                    <td className="align-middle">
                      {s.addedOn && typeof s.addedOn === "object" && s.addedOn.seconds
                        ? new Date(s.addedOn.seconds * 1000).toLocaleDateString()
                        : s.addedOn || ""}
                    </td>
                    <td className="align-middle">
                      <span className={s.active ? "badge-active" : "badge-inactive"}>
                        {s.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="align-middle">
                      <button
                        type="button"
                        className="btn btn-success btn-sm mr-1"
                        onClick={() => handleOnEdit(s)}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm mr-1"
                        style={{ background: s.active ? "#ffc107" : "#28a745", color: "#fff" }}
                        onClick={() => handleToggleActive(s.stylistId, s.active)}
                        title={s.active ? "Deactivate" : "Activate"}
                      >
                        <i className={`fa fa-${s.active ? "toggle-off" : "toggle-on"}`}></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleOnDelete(s.name, s.stylistId)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setOnStylist: (p) => {
      dispatch(setstylist(p));
    },
  };
};

export default connect(null, mapDispatchToProps)(StylistList);
